export default "__VITE_ASSET__243e4102__"